// extracted by mini-css-extract-plugin
export default {"title":"TariffInfo_title__kcPSc","content":"TariffInfo_content__qPZMp","bold":"TariffInfo_bold__DcTYj","btnWrap":"TariffInfo_btnWrap__TQE4O"};